import { Button, Dropdown, Image, Tooltip, Space } from 'antd';
import {
  CountryCode,
  countryCodeConvertImage,
  countryCodeList,
  countryTimezoneUtcOffset,
  deleteCookie,
  envCookieName,
  setCookie,
} from 'common';
import { changeCountryCode, changeLanguageCode, RootState, selectCurrentCountry } from 'modules';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import dayjs from 'common/util/dayjsConfig';
import { useTranslation } from 'react-i18next';
import { ButtonType } from 'antd/lib/button';

export interface CountryDropdownProp {
  type?: ButtonType;
  btnClassName?: string;
}

export const CountryDropdown: React.FC<CountryDropdownProp> = ({ type, btnClassName }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const countryCode = useSelector((state: RootState) => selectCurrentCountry(state));

  const onClickLocalizationMenu = useCallback(
    (e: { key: string }) => {
      if (countryCode === e.key) return;
      dispatch(changeCountryCode({ code: e.key }));
      dispatch(changeLanguageCode('en'));
      dayjs.tz.setDefault(e.key as CountryCode);
      // if ([CountryCode.HK, CountryCode.ID, CountryCode.PH].indexOf(e.key as CountryCode) !== -1)
      //   history.push('/employer/list');
      if (e.key === CountryCode.MY) history.push('/employer/list');
      if (e.key === CountryCode.PH) history.push('/employer/list');
      if (e.key === CountryCode.ID) history.push('/employer/list');
      if (e.key === CountryCode.SG) history.push('/employer/list');
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1);

      deleteCookie('locale');
      setCookie(envCookieName('locale'), `${'en'}-${e.key?.toUpperCase()}`);
    },
    [dispatch, history, countryCode]
  );

  const localizationMenu = () => {
    return countryCodeList.map((item: { code: CountryCode; name: string; image: string }) => ({
      label: (
        <Tooltip title={t(item.name)}>
          <Space className="align-items-baseline">
            <Image preview={false} style={{ height: '1.5rem', width: '1.5rem' }} src={item.image} />
            <span>
              {item.code.toUpperCase()} ({countryTimezoneUtcOffset[item.code]})
            </span>
          </Space>
        </Tooltip>
      ),
      key: item.code,
    }));
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      menu={{
        items: localizationMenu(),
        onClick: onClickLocalizationMenu,
        selectedKeys: [countryCode],
      }}
    >
      <Button className={btnClassName}>
        <Space>
          <Image
            preview={false}
            style={{ height: '1.5rem', width: '1.5rem' }}
            src={countryCodeConvertImage[countryCode]}
          />
          <span>
            {countryCode?.toUpperCase()} ({countryTimezoneUtcOffset[countryCode]})
          </span>
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
